
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'checkbox-button',
  props: {
    checked: {
      type: Boolean,
      default: false,
    },
  },
})
